import { useContext, useEffect } from 'react'
import { isMobileOnly, isTablet } from 'react-device-detect'
import { useFlag } from '@unleash/proxy-client-react'

import { UNLEASH_FEATURE_FLAGS } from 'utils/constants'
import { AppErrorContext } from './contexts/AppErrorContext'

export const DeviceErrorBoundary = ({ children, isDeviceError: isCurrentErrorDeviceRelated }) => {
  const tabletAccessEnabled = useFlag(UNLEASH_FEATURE_FLAGS.tabletAccess)
  const { setError: setAppError } = useContext(AppErrorContext)

  useEffect(() => {
    if ((isTablet && !tabletAccessEnabled) || isMobileOnly) {
      setAppError('mobile-access')
    } else if (isCurrentErrorDeviceRelated) {
      setAppError(undefined)
    }
  }, [isCurrentErrorDeviceRelated, setAppError, tabletAccessEnabled])

  return <>{children}</>
}
